import React from "react";
import classNames from "classnames";
import Truncate from 'react-truncate';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import withStyles from "@material-ui/core/styles/withStyles";
// import Tooltip from "@material-ui/core/Tooltip";
// import Favorite from "@material-ui/icons/Favorite";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CardFooter from "../../../components/Card/CardFooter.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle.jsx";

import accommodationImg from "../../../assets/img/bgFeatures.jpg";

const HotAccommodationsSection = props => {
    const { classes } = props;
    return (
        <div className={classes.section}>
            <div className={classes.container}>
                <h3>Alojamientos destacados</h3>
                <GridContainer>
                    <GridItem md={3} sm={3}>
                        <Card product plain>
                            <CardHeader image plain>
                                <Link to="/accommodation/5bb120fdab90a9053367610a">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb120fdab90a9053367610a/photos/1538336982432.jpg"
                                        alt="Villa Terracota Casa Antigua"
                                        className={classes.centerImg}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${accommodationImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/accommodation/5bb120fdab90a9053367610a">
                                    <h4 className={classes.cardTitle}>Villa Terracota (Casa Antigua)</h4>
                                </Link>
                                <div className={classes.truncatedText}>
                                    <Truncate lines={3} ellipsis={<span>... <Link to="/accommodation/5bb120fdab90a9053367610a">Ver más</Link></span>}>
                                        Casa de 2 pisos construida en adobe y
                                        caña brava. El primer piso cuenta con 4
                                        habitaciones con baño.
                                    </Truncate>
                                </div>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(30000).format('0,0')}</span> promedio/noche</span>
                                </div>
                                <Link to="/accommodation/5bb120fdab90a9053367610a">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem md={3} sm={3}>
                        <Card product plain>
                            <CardHeader image plain>
                                <Link to="/accommodation/5bb0dad2513f727cbe5a5bdf">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb0dad2513f727cbe5a5bdf/photos/1538319611529.jpg"
                                        alt="Nido de aguilas"
                                        className={classes.centerImg}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${accommodationImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/accommodation/5bb0dad2513f727cbe5a5bdf">
                                    <h4 className={classes.cardTitle}>Hábitat Experimental Nido de Águilas</h4>
                                </Link>
                                <div className={classes.truncatedText}>
                                    <Truncate lines={3} ellipsis={<span>... <Link to="/accommodation/5bb0dad2513f727cbe5a5bdf">Ver más</Link></span>}>
                                        Ven y disfruta la tranquilidad del campo,
                                        descubre donde se cultiva y cosecha en
                                        armonía con la naturaleza.
                                    </Truncate>
                                </div>
                            </CardBody>
                            <CardFooter plain>
                                {/**
                                 TODO: En Vista tablet se esta montando el precio sobre el boton ver mas
                                 */}
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(420000).format('0,0')}</span> promedio/noche</span>
                                </div>
                                <Link to="/accommodation/5bb0dad2513f727cbe5a5bdf">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem md={3} sm={3}>
                        <Card product plain>
                            <CardHeader image plain>
                                <Link to="/accommodation/5bb100db3ca7aa03327d7c3c">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb100db3ca7aa03327d7c3c/photos/1538327670608.jpg"
                                        alt="La Ponderosa"
                                        className={classes.centerImg}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${accommodationImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/accommodation/5bb100db3ca7aa03327d7c3c">
                                    <h4 className={classes.cardTitle}>La Ponderosa</h4>
                                </Link>
                                <div className={classes.truncatedText}>
                                    <Truncate lines={3} ellipsis={<span>... <Link to="/accommodation/5bb100db3ca7aa03327d7c3c">Ver más</Link></span>}>
                                        Cabaña de 2 pisos, en el primer piso
                                        cuenta con cocina, sala, comedor,
                                        chimenea, dos habitaciones y más.
                                    </Truncate>
                                </div>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(400000).format('0,0')}</span> promedio/noche</span>
                                </div>
                                <Link to="/accommodation/5bb100db3ca7aa03327d7c3c">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem md={3} sm={3}>
                        <Card product plain>
                            <CardHeader image plain>
                                <Link to="/accommodation/5bb0ee3e3ca7aa03327d7c1c">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb0ee3e3ca7aa03327d7c1c/photos/1538324838502.jpg"
                                        alt="Villa Rouse"
                                        className={classes.centerImg}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${accommodationImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/accommodation/5bb0ee3e3ca7aa03327d7c1c">
                                    <h4 className={classes.cardTitle}>Posada Eco Turística Villa Rouse</h4>
                                </Link>
                                <div className={classes.truncatedText}>
                                    <Truncate lines={3} ellipsis={<span>... <Link to="/accommodation/5bb0ee3e3ca7aa03327d7c1c">Ver más</Link></span>}>
                                        Servicio de alojamiento en Casa campestre de 1 nivel,
                                        una nueva en construcción contemporánea de ladrillo,
                                        cemento, manejo de ventanas amplias, teja de barro, con tres habitaciones
                                    </Truncate>
                                </div>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(70000).format('0,0')}</span> promedio/noche</span>
                                </div>
                                <Link to="/accommodation/5bb0ee3e3ca7aa03327d7c1c">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>

                    <GridItem md={7} sm={12} className={classNames(classes.divButtonMore)}>
                        <Link to="/accommodations">
                            <Button color="success" round block >
                                Ver todos los Alojamientos
                            </Button>
                        </Link>
                    </GridItem>
                </GridContainer>
            </div>
        </div>
    );
};

export default withStyles(styles)(HotAccommodationsSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/HotAccommodationsSection.jsx